export const Star = [
  {
    id: 4,
    title: "Best Support",
    img: "https://www.softwaresuggest.com/award_logo/2021/Best-Support.png",
    url: "https://www.softwaresuggest.com/cloudsocial",
  },

  {
    id: 2,
    title: "Get App",
    img: "https://www.cloudsocial.io/wp-content/uploads/image/icon/getapp.png",
    url: "https://www.getapp.com/marketing-software/a/cloudsocial/reviews/",
  },
  {
    id: 3,
    title: "Software Suggest",
    img:
      "https://www.cloudsocial.io/wp-content/uploads/image/icon/software5star.png",
    url: "https://www.softwaresuggest.com/cloudsocial",
  },
  {
    id: 1,
    title: "Capterra",
    img:
      "https://www.cloudsocial.io/wp-content/uploads/image/icon/capterra.png",
    url:
      "https://www.capterra.com/reviews/205569/CloudSocial?utm_source=vendor&utm_medium=badge&utm_campaign=capterra_reviews_badge",
  },
];
export const Policy = [
  {
    id: 1,
    title: "Privacy Policy",
    url: "https://www.iubenda.com/privacy-policy/84213336",
    tooltip: "Privacy & Policy",
  },
  {
    id: 2,
    title: "Cookie Policy",
    url: "https://www.iubenda.com/privacy-policy/84213336/cookie-policy",
    tooltip: "Cookie Policy",
  },
  {
    id: 3,
    title: "Terms and Conditions",
    url: "https://www.iubenda.com/terms-and-conditions/84213336",
    tooltip: "Terms and Conditions",
  },
  // {
  //   id: 3,
  //   title: "GDPR",
  //   // url: "https://www.iubenda.com/terms-and-conditions/84213336",
  //   tooltip: "GDPR Policy",
  // },
];

export const SecurityPolicy = [
  {
    id: 1,
    title: "Security",
    tooltip: "Security Policy",
    subtitle: "Infrastructure",
    desc:
      "CloudSocial servers are all hosted in the cloud by Amazon Web Services (AWS). The AWS infrastructure puts strong safeguards in place to help protect customer privacy.",

    desc1: [
      "All data is stored in highly secure AWS data centres.",
      "AWS ensures that all data is encrypted in transit with TLS across all services.",
    ],
  },
  {
    id: 2,
    subtitle: "Protecting Your Data",
    desc:
      "Protecting your data is of paramount importance and a constant focus here at CloudSocial.",
    desc1: [
      " Data is backed up daily and in some cases, more frequently than that.",
      " All access to the CloudSocial website is restricted to HTTPS encrypted connections.",
      " All data retrieval (and posting) to connected social accounts is done via HTTPS and using a unique, per user, access token (which you can revoke at any time).",
      " We never store credit card or payment details in our database. This is strictly stored and managed by FastSpring to ensure maximum security. FastSpring is certified to PCI Service Provider Level 1, the most stringent level of certification available.",
      " User passwords are encrypted. Passwords are never stored in plain text. Even our engineering team have no way to know what the password is.",
    ],
  },
  {
    id: 3,
    subtitle: "Employee Access",
    desc:
      "Access to infrastructure and other aspects of the CloudSocial environment, as well as customer data, is strictly limited to those within our team that absolutely need it.",
    desc1: [
      "Only our Engineering team has access to our production environment. SSH keys are required for console access to servers in all of our environments.",
      "Whilst we will often use aggregated snapshots of customer data to help us understand and identify performance, financial and business insights, we will only access individual customer records if it is necessary to do so in order to carry out a customer support request or a significant systems issue.",
    ],
  },
  {
    id: 5,
    subtitle: "How to Report a Security Incident",
    desc:
      "To report an incident of suspected abuse, misuse, or a security issue you have discovered you should contact ",
    url: "support@cloudsocial.io ",
    note:
      "immediately. For incidents that affect a single account, please reach out to us via our usual support channels.",
    desc1: [
      "CloudSocial support team will acknowledge your report, usually within 1 business day.",
      " A point of contact will be assigned. This person will be responsible for keeping track of the issue, as well as keeping you updated. Please note that this person may need to liaise with you to better understand the reported issue and the circumstances around it.",
      "We will investigate the issue and determine the impact.",
      "In most cases, for security reasons it is likely that we will be unable to disclose details of the issue until our investigation has been completed.",
      "Once the issue has been resolved, we will post an update along with thanks and credit for the discovery.",
    ],
  },
  {
    id: 6,
    question: "",
    ans: "",
    desc1: [],
  },
];

export const GDPR = [
  {
    id: 1,
    subtitle: "CloudSocial and the General Data Protection Regulation (GDPR)",
    desc:
      "In 2016 the European Commission approved and adopted a new framework for European data protection law called the General Data Protection Regulation (GDPR). The GDPR requirements have become effective on May 25, 2018 and have affected all companies who are processing personal data of individuals in the EU. Here at CloudSocial we embrace the GDPR regulation and see it as an opportunity to further improve how we communicate with you, use and share your data and fundamentally, how we place your privacy, security and rights at the forefront of everything that we do. As both a data controller and processor, we have taken measures to ensure our compliance with the GDPR.",
    desc1: [],
  },
  {
    id: 2,
    subtitle: "GDPR preparedness checklist",
    desc:
      "We have ensured complete compliance with the GDPR. Below is a high-level overview of the key activities we have performed: ",
    desc1: [
      " Appointed a Data Protection Officer",
      " Assessed our product and business to determine areas impacted by GDPR",
      " Conducted an internal audit to ensure that all third parties and suppliers used by CloudSocial are GDPR compliant",
      " Perform necessary changes to the platform (incl. easier to access communication preference controls, explicit acceptance of Terms and Privacy Policies on signup)",
      " Updated our Privacy Policy",
      " Updated our Terms & Conditions ",
      "Created a dedicated page to document our GDPR activities and compliance ",
      "Created a dedicated page to outline how we secure our customers data",
      "Communicate our compliance with our customers.",
    ],
  },
  {
    id: 3,
    title1: "Frequently Asked Questions",
    question:
      "Does CloudSocial have a Data Processing Agreement (DPA) we can sign?",
    ans:
      "As a Data Processor, our updated Terms & Conditions include the necessary data processing clauses. When we are acting as a Data Controller, the terms of our Privacy Policy will govern. If you specifically require a signed copy of our Terms & Conditions, then please contact ",
    url: "support@cloudsocial.io",
    ans2: " and we will send you a copy to sign.",
    desc1: [],
  },
  {
    id: 4,
    question: "Where does CloudSocial store its data?",
    ans:
      "Our server infrastructure is hosted by Amazon Web Services (AWS) - in their North Virginia (US) region. You can read more about our Security provisions and overview by heading to our Security section.",
    desc1: [],
  },
  {
    id: 5,
    subtitle:
      "Can you delete my data or answer any other questions about my data?",
    desc:
      "Please login to your account and navigate to ‘Delete my Account’ sections to permanently delete your CloudSocial account and it’s associated data. Alternatively, you may email us if you'd like to exercise your rights under GDPR. You can request to have your data deleted as well as request further information on how your data is being used - amongst other things. ",
    desc1: [],
  },
  {
    id: 6,
    question: "How is my data being used?",
    ans:
      "We are continually auditing the third-party services that we use, in order to ensure that we are only making use of services that add value to CloudSocial, the product and its customers.    To view a full list of those that we use, please head over to our Privacy Policy. If you have any further questions please don't hesitate to get in touch with us via our Support Chat or by emailing us on ",
    desc1: [],
    url: "support@cloudsocial.io.",
  },
  {
    id: 7,
    question: "",
    ans: "",
    desc1: [],
  },
];
